import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys } from "vue";
import { ref, toRefs } from 'vue';
import { Search } from '@element-plus/icons-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'MctSelectSearch',
  props: {
    searchValue: {
      default: () => ['', '']
    },
    searchPlaceholder: {
      default: 'Search'
    },
    selectWidth: {
      default: '90px'
    },
    hasSuffix: {
      type: Boolean,
      default: true
    },
    options: {
      default: () => [{
        label: 'Cluster',
        value: '0'
      }, {
        label: 'Zone',
        value: '3'
      }, {
        label: 'Check',
        value: '1'
      }, {
        label: 'URL',
        value: '2'
      }]
    }
  },
  emits: ["triggerSelectSearch", "changeSearchLevel"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      searchValue,
      options,
      selectWidth
    } = toRefs(props);
    const selectStyle = ref({
      width: selectWidth
    });
    // @ts-ignore
    const currSearchLevel = ref(searchValue.value[0] !== '' ? searchValue.value[0] : options.value[0].value);
    const searchVal = ref(searchValue.value[1]);
    const emits = __emit;
    const handleSearchLevelChange = () => {
      emits('changeSearchLevel', currSearchLevel.value);
    };
    const search = () => {
      emits('triggerSelectSearch', [currSearchLevel.value, searchVal.value]);
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createBlock(_component_el_input, {
        onKeyup: _withKeys(search, ["enter"]),
        modelValue: searchVal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchVal.value = $event),
        placeholder: _ctx.searchPlaceholder,
        class: "select-search no-border",
        "suffix-icon": _ctx.hasSuffix ? _unref(Search) : ''
      }, {
        prepend: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: currSearchLevel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currSearchLevel.value = $event),
          onChange: handleSearchLevelChange,
          placeholder: "Cluster",
          style: _normalizeStyle(selectStyle.value)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), option => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: option.label,
              label: option.label,
              value: option.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "style"])]),
        _: 1
      }, 8, ["modelValue", "placeholder", "suffix-icon"]);
    };
  }
});